import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

function normalizeCommunityId(communityId) {
  return communityId === '-1' || communityId === -1 ? '' : communityId
}

function setCommunityIdIfValid(target, communityId) {
  const value = normalizeCommunityId(communityId)
  if (value) {
    target.communityId = value
  } else {
    delete target.communityId
  }
}

// 获取报修设置列表
export function listRepairSettings(params) {
  return new Promise((resolve, reject) => {
    setCommunityIdIfValid(params, params.communityId)
    request({
      url: '/repair.listRepairSettings',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取报修设置列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加报修设置
export function saveRepairSetting(data) {
  return new Promise((resolve, reject) => {
    setCommunityIdIfValid(data, data.communityId || getCommunityId())
    request({
      url: '/repair.saveRepairSetting',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '添加报修设置失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新报修设置
export function updateRepairSetting(data) {
  return new Promise((resolve, reject) => {
    setCommunityIdIfValid(data, data.communityId || getCommunityId())
    request({
      url: '/repair.updateRepairSetting',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '更新报修设置失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除报修设置
export function deleteRepairSetting(settingId) {
  return new Promise((resolve, reject) => {
    const data = {
      settingId
    }
    request({
      url: '/repair.deleteRepairSetting',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除报修设置失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取字典数据
export function getDict(dictType, state) {
  return new Promise((resolve, reject) => {
    const params = {
      dictType,
      state
    }
    request({
      url: '/dict.getDict',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res.data)
      } else {
        reject(new Error(res.msg || '获取字典数据失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
